import { AppBar, Box, styled } from "@mui/material";
import AppIconButton from "components/AppIconButton";
import { ReactComponent as BackImg } from "assets/nav_icon_back.svg";
import { ReactComponent as RefreshImg } from "assets/nav_icon_reload.svg";
import Colors from "util/colors";

const Wrapper = styled(AppBar)({
  position: "sticky",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100vw",
  height: "10.5vw",
  backgroundColor: Colors.get().main,
  boxShadow: "none",
});

const Title = styled(Box)({
  position: "absolute",
  width: "100%",
  textAlign: "center",
  color: "#fff",
  fontWeight: 600,
  fontSize: "15px",
  lineHeight: "22px",
});

/**
 * プロパティ定義
 */
type Props = {
  /** タイトル */
  title?: string;
  /** 戻るボタン押下時イベント */
  onClickBack?: () => void;
  /** 再読み込み押下時イベント */
  onClickReload?: () => void;
};

/**
 * アプリ共通のヘッダー
 * @param param コンポーネントのProps
 */
export default function Header({
  title,
  onClickBack,
  onClickReload
  }: Props) {
  return (
    <Wrapper>
      <Title>
        {title}
      </Title>

      {/* 戻るボタン */}
      {onClickBack && (
        <AppIconButton
         sx={{ marginLeft: "3.75vw" }}
          onClick={() => onClickBack()}
          >
          <BackImg width="10px" height="18px" />
        </AppIconButton>
      )}
      
      {onClickReload && ( // 更新ボタン
        <AppIconButton
          sx={{ marginRight: "3.75vw" }}
          onClick={() => onClickReload()}
        >
          <RefreshImg width="18px" height="18px" />
        </AppIconButton>
      )}
    </Wrapper>
  );
}
